import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/global.scss';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const app = createApp(App);
app.use(router);
app.use(Toast, { position: POSITION.BOTTOM_RIGHT, timeout: 3000 });
app.mount('#app');